import type React from "react";
import SetTrial from "./setTrial/SetTrial";
import Price from "./prices/Price";
import Cards from "./Cards";

const Config: React.FC = () => {
  return (
    <section className="container mx-auto px-4 py-20">
      <div className="flex flex-col md:flex-row items-center gap-8 ">
        <div className="w-full md:w-1/2 max-w-md">
          <SetTrial />
        </div>
        <div className="w-full md:w-1/2 max-w-md">
          <Price />
        </div>
      </div>
      <Cards />
    </section>
  );
};

export default Config;
